module.exports = __webpack_public_path__ + "img/5-2.6fa2e7f3.svg";